import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MarketplaceCardModule } from 'src/app/shared/components/marketplace-card/marketplace-card.module';
import { SwiperModule } from 'swiper/angular';
import { MaterialModule } from '@/material/material.module';
import { HomePopularCategoryComponent } from './home-popular-category/home-popular-category.component';
import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './home.component';
import { AdCreationGuideComponent } from './ad-creation-guide/ad-creation-guide.component';
import { SearchSectionComponent } from './search-section/search-section.component';
import { TranslateModule } from '@ngx-translate/core';
import { ProductListModule } from '../product-list/product-list.module';

@NgModule({
  declarations: [
    HomeComponent,
    SearchSectionComponent,
    AdCreationGuideComponent,
    HomePopularCategoryComponent,
  ],
  imports: [
    CommonModule,
    HomeRoutingModule,
    MarketplaceCardModule,
    ReactiveFormsModule,
    MaterialModule,
    SwiperModule,
    FormsModule,
    TranslateModule,
    ProductListModule,
  ],
})
export class HomeModule {}
